import { Box, FormControl, Input } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';
import { makeSelectOptions } from './makeSelectOptions';
import { Select } from 'packages/common-frontend/components/Select';

export const ValueConfigEditor = ({
  value,
  onChange,
}: {
  value: CreditAgreement.Config.ConcentrationLimit.Value.Config;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Value.Config,
  ) => void;
}) => {
  const selectOptions = makeSelectOptions(
    CreditAgreement.Config.ConcentrationLimit.Value.ValueTypeIterable,
  );

  return (
    <Box mt={4} mb={4}>
      <FormControl flex="1">
        <ConcentrationCalcFieldLabel
          mb={1}
          label="Limit Value"
          tooltip="Select the value that represents the concentration limit."
        />
        <Input
          id="value"
          name="value"
          value={value.limit}
          onChange={(event) =>
            // @dual_cc:todo: validate formulas.
            // also validate against valueType.
            onChange({
              ...value,
              type: 'formula',
              limit: event.target.value,
            })
          }
        />

        <ConcentrationCalcFieldLabel
          mb={1}
          label="Value Type"
          tooltip="Select the type of concentration limit. The standard value type is percentage limit."
        />
        <Select<CreditAgreement.Config.ConcentrationLimit.Value.ValueType>
          value={value.valueType}
          onChange={(val) => {
            if (val) {
              onChange({
                ...value,
                valueType: val,
              });
            }
          }}
          options={selectOptions}
        />
      </FormControl>
    </Box>
  );
};
